import React, { useState, useEffect } from 'react';
import {translate} from "../../../../utils/Common"
import { FormGrid, Field } from "@/components/ui/form-field";

// campos para ingresar medidas 
const FieldSizes = ({ register, unidad }) => {
    // para calcular dimensiones
    const [alto, setAlto] = useState(0);
    const [largo, setLargo] = useState(0);
    const [ancho, setAncho] = useState(0);
    const [clasificacion, setClasificacion] = useState('S');
    // calcular la clasificacion
    useEffect(() => {
        const getClasificacionPaquete = () => {
            let numeros = [alto, largo, ancho];

            for (let i = 0; i < 2; i++)
            {
                for (let f = 0; f < 2 - i; f++)
                {
                    if (numeros[f] > numeros[f + 1])
                    {
                        let aux = numeros[f];
                        numeros[f] = numeros[f + 1];
                        numeros[f + 1] = aux;
                    }
                }
            }

            let altoAux = numeros[0];
            let anchoAux = numeros[1];
            let largoAux = numeros[2];
            
            if (altoAux > (unidad ? 14.96 : 38) || anchoAux > (unidad ? 17.32 : 44) || largoAux > (unidad ? 23.62 : 60))
            {
                setClasificacion('XG');
            }
            else if (altoAux <= (unidad ? 4.33 : 11))
            {
                setClasificacion('P');
            }
            else if (altoAux > (unidad ? 4.33 : 11) & altoAux <= (unidad ? 9.45 : 24))
            {
                setClasificacion('M');
            }
            else if (altoAux > (unidad ? 9.45 : 24) & altoAux <= (unidad ? 14.96 : 38))
            {
                setClasificacion('G');
            }
        }

        getClasificacionPaquete();
        return () => getClasificacionPaquete();
    }, [alto, largo, ancho, unidad]);
    
    const unitLabel = unidad === 0 ? 'cm' : 'inch';

    return (
        <FormGrid className="mt-4">
            <Field
                span={3}
                type="number"
                id="inputAlto"
                name="alto"
                placeholder="0"
                label={`${translate("global.high")} (${unitLabel})`}
                inputRef={register}
                onChange={ (e) => setAlto(e.target.value ? Number(e.target.value) : 0) }
            />

            <Field
                span={3}
                type="number"
                id="inputLargo"
                name="largo"
                placeholder="0"
                label={`${translate("global.long")} (${unitLabel})`}
                inputRef={register}
                onChange={ (e) => setLargo(e.target.value ? Number(e.target.value) : 0) }
            />

            <Field
                span={3}
                type="number"
                id="inputAncho"
                name="ancho"
                placeholder="0"
                label={`${translate("global.width")} (${unitLabel})`}
                inputRef={register}
                onChange={ (e) => setAncho(e.target.value ? Number(e.target.value) : 0) }
            />

            <Field
                span={3}
                id="inputClasificacion"
                name="size"
                label={translate("global.sort")}
                value={ clasificacion }
                readOnly
                className="bg-muted/30 font-semibold"
                inputRef={register}
            />
        </FormGrid>
    );
}

export default FieldSizes;